
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { useState } from 'react';
import Heading from '../shared/components/Heading.js';
import "../shared/css/index.css"
import "../shared/components/Heading.css"
import { Playground, PropsTable } from 'docz'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"heading"}}>{`Heading`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const sizes = [14, 16, 18, 20, 24, 32, 48]\n  const weights = [100, 200, 300, 400, 500, 600, 700, 800, 900]\n  const colors = [\'dark\', \'link\', \'yellow\', \'red\', \'blue\', \'green\', \'light\']\n  const [size, setSize] = useState(24)\n  const [weight, setWeight] = useState(600)\n  const [color, setColor] = useState(\'dark\')\n  const [uppercase, setUppercase] = useState(false)\n  return (\n    <div>\n      <div>\n        <label>Tamaño</label>\n        <select\n          value={size}\n          onChange={e => {\n            setSize(Number(e.target.value))\n          }}\n        >\n          {sizes.map(sizeVal => (\n            <option value={sizeVal}>{sizeVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Grosor</label>\n        <select\n          value={weight}\n          onChange={e => {\n            setWeight(Number(e.target.value))\n          }}\n        >\n          {weights.map(weightVal => (\n            <option value={weightVal}>{weightVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Color</label>\n        <select\n          value={color}\n          onChange={e => {\n            setColor(e.target.value)\n          }}\n        >\n          {colors.map(colorVal => (\n            <option value={colorVal}>{colorVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Mayúsculas</label>\n        <input\n          type=\"checkbox\"\n          onChange={e => {\n            setUppercase(u => !u)\n          }}\n        />\n      </div>\n\n      <Heading\n        size={size}\n        weight={weight}\n        color={color}\n        uppercase={uppercase}\n      >\n        Encabezado\n      </Heading>\n    </div>\n  )\n}'} __scope={{props: this ? this.props : props,useState,Heading}}>
  { () => {
    const sizes = [14,16,18,20,24,32,48];
    const weights = [100,200,300,400,500,600,700,800,900]
    const colors = ["dark", "link", "yellow", "red", "blue", "green", "light"]
    const [size, setSize] = useState(24);
    const [weight, setWeight] = useState(600);
    const [color, setColor] = useState("dark");
    const [uppercase, setUppercase] = useState(false);
return (
  <div>
    <div>
      <label>Tamaño</label>
      <select value={size} onChange={
        (e) => {
          setSize(Number(e.target.value))
        }
      }>
        {sizes.map(sizeVal => <option value={sizeVal}>{sizeVal}</option>)}
      </select>
    </div>
    <div>
      <label>Grosor</label>
      <select value={weight} onChange={
        (e) => {
          setWeight(Number(e.target.value))
        }
      }>
        {weights.map(weightVal => <option value={weightVal}>{weightVal}</option>)}
      </select>
    </div>
    <div>
      <label>Color</label>
      <select value={color} onChange={
        (e) => {
          setColor(e.target.value)
        }
      }>
        {colors.map(colorVal => <option value={colorVal}>{colorVal}</option>)}
      </select>
    </div>
    <div>
      <label>Mayúsculas</label>
      <input type="checkbox" onChange={(e) => {
        setUppercase(u => !u)
      }} />
    </div>

    <Heading size={size} weight={weight} color={color} uppercase={uppercase}>Encabezado</Heading>
  </div>
)
  } }
</Playground>
<PropsTable of={Heading} />
           </MDXTag>
  }
}
  